import {download, downloadJCourse, downloadLoading, get, J_COURSE_URL, post, postByJson} from '../https.js';

export default {
    save(params) {
        return postByJson(J_COURSE_URL + 'teacher/createJCourse', params);
    },
    // 根据条件查询开设的精品课分页
    getTeacherCourseList(params) {
        return get(J_COURSE_URL + 'teacher/page', params);
    },

    getJCourse(param) {
        return get(J_COURSE_URL + 'teacher/jCourseInfo', param);
    },

    // 老师个人中心数据统计
    getStatistic() {
        return get(J_COURSE_URL + 'teacher/statistic');
    },

    // 更新课程
    updateJCourse(params) {
        return postByJson(J_COURSE_URL + 'teacher/updateJCourse', params);
    },

    // 更新模块
    updateJCourseModuleInfo(params) {
        return postByJson(J_COURSE_URL + 'teacher/updateJCourseModuleInfo', params);
    },

    // 模块详情
    getJCourseModuleInfo(params) {
        return get(J_COURSE_URL + 'teacher/jCourseModuleInfo', params);
    },

    // 重置模块
    setJCourseModule(params) {
        return postByJson(J_COURSE_URL + 'teacher/setJCourseModule', params);
    },

    // 课程团队
    getCourseManage(params) {
        return get(J_COURSE_URL + 'teacher/getCourseManage', params);
    },

    // 查询考核标准
    selectExamStandard(params) {
        return get(J_COURSE_URL + 'student/examStandard/' + params)
    },
    addCourseCase(params) {
        return postByJson(J_COURSE_URL + 'teacher/addCourseCase', params)
    },
    pageLessonNotes(params) {
        return get(J_COURSE_URL + 'teacher/pageLessonNotes', params);
    },
    deleteCourseCase(params) {
        return get(J_COURSE_URL + 'teacher/getCourseCase', params);
    },

    // 获取课程开设的期次列表
    getCourseSemester(params) {
        return get(J_COURSE_URL + 'semester/list', params);
    },
    // 期次下数据概览
    getStatisticBySemesterId(params) {
        return get(J_COURSE_URL + 'statistic/semester', params);
    },
    // 课程下的数据概览（不分期次）
    getAllStatisticInfo(params) {
        return get(J_COURSE_URL + 'statistic/all', params);
    },

    //各期次下数据概览
    getSemesterStatisticList(params) {
        return get(J_COURSE_URL + 'statistic/list', params);
    },

    //导出数据
    exportStatistic(params) {
        return downloadJCourse(J_COURSE_URL + 'statistic/export', params);
    },

    //各期次下线上互动统计
    getThemeList(params) {
        return get(J_COURSE_URL + 'statistic/listTheme', params);
    },

    //学生课程学校资料列表
    getStudentStudyProgressList(params) {
        return get(J_COURSE_URL + 'studyProgress/list', params);
    },

    //保存精品课用户学习进度关联表
    saveStudentStudyProgress(params) {
        return postByJson(J_COURSE_URL + 'studyProgress/save', params);
    },

    // 查询我的学习时长
    studentLearnStatistic(courseId, courseSemesterId) {
        return get(J_COURSE_URL + 'student/studentLearnStatistic/' + courseSemesterId + '/' + courseId)
    },

    //保存精品课用户学习进度关联表
    updatePower(params) {
        return postByJson(J_COURSE_URL + 'teacher/power', params);
    },
    getPaperStatistical(params) {
        return get(J_COURSE_URL + 'statistic/paperStatisticalDetails', params)
    },
    /**查阅**/
    // 查阅-试卷发送测评信息、试题信息
    selectTestPaperInfo(param) {
        return get(J_COURSE_URL + 'exams/selectTestPaperInfo', param)
    },
    selectBasicDataInfo(param) {
        return get(J_COURSE_URL + 'exams/selectBasicDataInfo', param)
    },
    /**查阅-试题分析**/
    // 查阅-试题分析-试卷发送试题数量
    selectSendExercise(param) {
        return get(J_COURSE_URL + 'exams/selectSendExercise', param)
    },
    // 查阅-试题分析-学生答题情况
    studentAnswer(param) {
        return get(J_COURSE_URL + 'exams/studentAnswer', param)
    },
    /**查阅-学生分析**/
    // 查阅-学生分析-获取学生答卷结果数据分页.
    studentResultDataList(param) {
        return get(J_COURSE_URL + 'exams/studentResultDataList', param)
    },
    // 查阅-学生分析、试题分析-学生查阅-试卷发送试题数量
    stuConsultSendExerciseNum(param) {
        return get(J_COURSE_URL + 'exams/stuConsultSendExerciseNum', param)
    },
    // 查阅-学生分析、试题分析-学生查阅-获取该学生该题的答案(不包括分录、表格)
    getStudentExerciseAnswer(param) {
        return get(J_COURSE_URL + 'exams/getStudentExerciseAnswer', param)
    },
    // 查阅-导出成绩
    exportClassScoreExam(param) {
        return downloadLoading(J_COURSE_URL + 'exams/exportStudentAchievement', param, '正在导出中')
    },

    //下载教师上传资源
    downLoadResource(param) {
        return download(J_COURSE_URL + "teacherResources/downLoadResource", param);
    },

    // 获取考核标准信息
    getExamineStandardInfo(param) {
        return get(J_COURSE_URL + 'teacher/examineStandardInfo/' + param)
    },
    // 考核标准设置
    examineStandardSetting(param) {
        return post(J_COURSE_URL + 'teacher/examineStandardSetting', param)
    },
}



// WEBPACK FOOTER //
// ./src/components/tools/request/jCourse/https-jCourse.js